
import { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowDown, faArrowUp, faFolderOpen, faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { historicoService } from "../../../_services/historico.service";
import { Tabla } from "../../../components/Table/Table";
import moment from "moment";
import { Alert, Button } from "react-bootstrap";
import { Filter } from "./Components/Filter";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";

const Historial = () => {
  const [showFilter, setShowFilter] = useState(true);
  const [showTable, setShowTable] = useState(true);
  const [dataList, setDataList] = useState([]);

  useEffect(() => {
    const getData = async () => {
      let res = await historicoService.getHistorico();

      setDataList(res);
    };
    getData();
  }, []);

  const columns = [
    {
      title: "Fecha",
      dataIndex: "fecha",
    },
    {
      title: "Usuario",
      dataIndex: "usuario",
    },
    {
      title: "Abogado",
      dataIndex: "apellnom",
    },
    {
      title: "Inmueble",
      dataIndex: "inmueble",
    },
    {
      title: "Recurso",
      dataIndex: "recurso",
    },
    {
      title: "Descripción",
      dataIndex: "descripcion",
      width: "30%",
    },
  ];

  const formatData = (arrayData) => {
    try {
      return arrayData.map(item => {
        return {
          ...item,
          fecha: moment(item.createdAt).format("DD/MM/YYYY"),
          apellnom: `${item?.user?.apellido} ${item?.user?.nombre}`,
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };

  function exportData(list) {
    let filename = `historico_${new Date().getTime()}.xlsx`;

    const dataList = list.map((e) => {
      return {
        "Fecha": moment(e.createdAt).format("DD/MM/YYYY"),
        "Usuario": e.usuario,
        "Abogado": `${e?.user?.apellido} ${e?.user?.nombre}`,
        "Inmueble": e.inmueble,
        "Recurso": e.recurso,
        "Descripción": e.descripcion
      };
    });

    let name = "Inmuebles";

    return {
      dataList,
      filename,
      name
    };
  }

  return (
    <div className="section-content">
      <div className="section-title d-flex align-items-center">
        <FontAwesomeIcon icon={faFolderOpen} style={{ fontSize: 34, color: "#999999" }} />
        <span>Historial</span>
      </div>

      <Alert variant={"info"} className="d-flex flex-row align-items-center">
        <FontAwesomeIcon icon={faInfoCircle} size="2x" className="mr-3" />
        En fase de prueba.
      </Alert>

      <div className="buttons-filter">
        <h3 className="mr-3">Filtros:</h3>
        <div className="button-filter">
          {showFilter ? (
            <Button
              variant="danger"
              onClick={() => setShowFilter(false)}
              className="danger-button d-flex align-items-center"
              style={{ maxWidth: 105 }}
            >
              <FontAwesomeIcon icon={faArrowDown} size="1x" /><span className="ml-2">Ocultar</span>
            </Button>
          )
            : (
              <Button
                onClick={() => setShowFilter(true)}
                className="custom-button d-flex align-items-center"
                style={{ maxWidth: 105 }}
              ><FontAwesomeIcon icon={faArrowUp} size="1x" /><span className="ml-2">Mostrar</span>
              </Button>
            )}
        </div>
      </div>
      <div className="section-filter">
        <Filter
          showFilter={showFilter}
          setShowFilter={setShowFilter}
          style={{ marginBottom: "30px" }}
          action={historicoService.getHistorico}
          setShowTable={setShowTable}
          setData={setDataList}
        />
      </div>
      {showTable ? (
        <div className="section-table">
          <Tabla dataList={formatData(dataList)} columns={columns} />
          <div className="mt-3">
            <div style={{ maxWidth: 170 }}>
              <DescargarExcel data={exportData(dataList)} />
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};


export default Historial;